import { render, staticRenderFns } from "./calculators-layout.vue?vue&type=template&id=835168ac"
import script from "./calculators-layout.vue?vue&type=script&lang=js"
export * from "./calculators-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports